// faq_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["question", "answer", "openIcon", "closeIcon"]

  connect() {
    // Close all FAQs by default
    this.questionTargets.forEach((question, index) => {
      this.closeItem(index)
    })
  }

  toggle(event) {
    const button = event.currentTarget
    const index = this.questionTargets.indexOf(button)

    // Get current state from aria-expanded attribute
    const isExpanded = button.getAttribute("aria-expanded") === "true"

    if (isExpanded) {
      this.closeItem(index)
    } else {
      this.openItem(index)
    }
  }

  openItem(index) {
    // Show the answer
    this.answerTargets[index].classList.remove("hidden")

    // Update button state
    this.questionTargets[index].setAttribute("aria-expanded", "true")

    // Toggle icons
    this.openIconTargets[index].classList.add("hidden")
    this.closeIconTargets[index].classList.remove("hidden")
  }

  closeItem(index) {
    // Hide the answer
    this.answerTargets[index].classList.add("hidden")

    // Update button state
    this.questionTargets[index].setAttribute("aria-expanded", "false")

    // Toggle icons
    this.openIconTargets[index].classList.remove("hidden")
    this.closeIconTargets[index].classList.add("hidden")
  }
}
